import { useEffect, useState } from "react"

export type ImageNaturalSize = { w: number; h: number }

export function useImageNaturalSize(url: string | null | undefined, enabled = true): ImageNaturalSize | null {
  const [size, setSize] = useState<ImageNaturalSize | null>(null)

  useEffect(() => {
    if (!enabled || !url) {
      setSize(null)
      return
    }

    let cancelled = false
    const img = new Image()
    img.onload = () => {
      if (cancelled) return
      setSize({ w: img.naturalWidth, h: img.naturalHeight })
    }
    img.onerror = () => {
      if (cancelled) return
      setSize(null)
    }
    img.src = url

    return () => {
      cancelled = true
    }
  }, [url, enabled])

  return size
}
